import React from "react";
import Navigation from "./navigation"
import Footer from "./footer"

const PageLayout = ({ children, notHome }) => {
  return (
    <React.Fragment>

      <Navigation backgroundClass={ notHome && 'coloredNav'} />

        { children }

      <Footer />

    </React.Fragment>
  )
}

PageLayout.defaultProps = {
  notHome: true
}

export default PageLayout;